import React from 'react';
import { calculatePercentage } from '../../../lib/utils/math';
import { Progress } from '../../../components/progress/Progress';

import styles from './stage-header.module.scss';
type StageHeaderProps = {
  suffix?: React.ReactNode;
  actions?: React.ReactNode;
  name: string;
  completed: number;
  total: number;
  isActive?: boolean;
  progressColor?: string;
};

export const StageHeader: React.FC<StageHeaderProps> = ({
  suffix,
  actions,
  name,
  completed,
  total,
  isActive,
  progressColor = 'var(--color-secondary)',
}) => {
  const progress = calculatePercentage(completed, total);

  return (
    <div className={styles['container']}>
      <div className={styles['header']}>
        <div className={styles['title']} data-is-active={!!isActive}>
          {suffix}

          <h3>{name}</h3>
        </div>

        <div className={styles['header-progress']}>
          <div className={styles['progress-indicator']}>
            {completed}/{total}
          </div>

          {actions}
        </div>
      </div>

      <Progress percentage={progress} color={progressColor} />
    </div>
  );
};

/**
 * The stage's order badge. Exported and rendered by stage.tsx and the calendar
 * pages, so it stays a component rather than being inlined.
 */
export const StageNumber = ({
  isActive,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'div'> & { isActive?: boolean }) => (
  <div
    className={className ? `${styles['stage-number']} ${className}` : styles['stage-number']}
    data-is-active={!!isActive}
    {...props}
  />
);
